<template>
  <div class="selesForm">
    <el-form ref="form" :model="form" :rules="rules" inline>
      <!-- <el-form-item label="编号" prop="fBillNo">
        <el-input v-model="form.fBillNo" :disabled="true" />
      </el-form-item> -->
      <el-form-item label="经销商" prop="fDistributorID">
        <el-select
          v-model="form.fDistributorID"
          style="width:350px;"
          placeholder="请选择"
          size="small"
          filterable
          clearable
          @change="selectDisChange"
        >
          <el-option
            v-for="item in form.distributorList"
            :key="item.fid"
            :label="item.fName"
            :value="item.fid"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="年份" prop="fYear">
        <el-select
          v-model="form.fYear"
          style="width:100px;"
          placeholder="请选择"
          size="small"
          @change="selectYearChange"
        >
          <el-option
            v-for="item in form.yearList"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
      </el-form-item>
    </el-form>
    <el-table
      :data="form.infoEntrys"
      class="tb-edit"
      style="width: 100%"
      highlight-current-row
    >
      <el-table-column label="月份" width="180" prop="fMonth" />
      <el-table-column label="销售额度(元)" width="200">
        <template
          scope="scope"
          :style="{ display: display ? 'none' : 'block' }"
        >
          <!-- <el-input-number
            v-model="scope.row.fQuota"
            size="small"
            placeholder="请输入内容"
            :style="{ display: display ? 'block' : 'none' }"
            :min="0"
          />
          <span :style="{ display: display ? 'none' : 'block' }">{{
            scope.row.fQuota
          }}</span> -->
          <el-input-currency v-model="scope.row.fQuota" :scale="2" size="small" />

        </template>
      </el-table-column>
      <el-table-column
        label="备注"
        :style="{ display: display ? 'none' : 'block' }"
      >
        <template scope="scope">
          <el-input
            v-model="scope.row.fDes"
            size="small"
            placeholder="请输入内容"
            :style="{ display: display ? 'block' : 'none' }"
          />
          <!-- <span :style="{ display: display ? 'none' : 'block' }">{{
            scope.row.fDes
          }}</span> -->
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作">
        <template scope="scope">
          <el-button
            v-if="!display"
            size="small"
            @click="editOpen()"
          >编辑</el-button>
          <el-button
            v-if="display"
            size="small"
            @click="handleEdit(scope.$index, scope.row)"
          >取消编辑</el-button>
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
export default {
  props: {
    form: Object
  },
  data: function() {
    return {
      isReadonly: true,
      rules: {
        fDistributorID: [
          { required: true, message: '必填项', trigger: 'change' }
        ],
        fYear: [{ required: true, message: '必填项', trigger: 'change' }]
      },
      display: true
    }
  },
  //   computed: {
  //     isEdit: function() {
  //       return !!this.form.fRegionID;
  //     }
  //   },
  mounted: function() {
    // console.log(this.form, 'this.form')
    this.form.fYear = this.form.yearData
    this.form.fDistributorID = this.form.distributorList[0].fid
    this.getDistributor(this.form.fDistributorID, this.form.fYear)
  },
  created() {},
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          onValid(this.form)
        } else {
          return false
        }
      })
    },
    selectDisChange(row) {
      // console.log(row)
      this.getDistributor(row, this.form.fYear)
    },
    selectYearChange(row) {
      // console.log(row)
      this.getDistributor(this.form.fDistributorID, row)
    },
    getDistributor(fId, year) {
      if (fId !== '' && year !== '') {
        this.$httpPost(
          'BasicInformation/DistributorQuota/GetDistributorQuotaForAdd',
          { fDistributorID: this.form.fDistributorID, fYear: this.form.fYear }
        ).then((res) => {
          // console.log(res, 'res')
          this.form.infoEntrys = res.datalist.infoEntrys
        })
      }
    },
    handleEdit(index, row) {
      // console.log(index, 'index')
      this.table = row
      this.isReadonly = true
    },
    editOpen() {
      this.display = true
      this.isReadonly = false
    }
  }
}
</script>

<style lang="less" >
.selesForm {
  .el-table td,
  .el-table th {
    padding: 5px 0;
  }
}
</style>
